import React from 'react';

import { DropDownSelect } from 'screens/performanceReview/components/GoalForm';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 30%;
`;

const SelectPreview = ({ question }) => (
  <Wrapper>
    <DropDownSelect answerOptions={question.answerOptions} selectedAnswerOptions={[]} isGoalSectionEditable />
  </Wrapper>
);

export default SelectPreview;
